<template>
    <div class="batch-publish-comp">
        <div class="left table-list">
            <div class="mask"></div>
            <!-- <div v-if="housesCid.length" class="selected-tips">
                <div class="wording">
                    已選取 {{housesCid.length}} 個房源
                </div>
            </div> -->
            <div v-if="this.filterTag.length" class="filter-tips">
                <span class="result">
                    {{filterByLandlord.length}} 個結果
                </span>
                <span class="item" v-for="(item, index) in this.filterTag" :key="index">
                    {{item}}
                </span>
            </div>
            <div class="table-list-title">
                <!-- <span class="checkbox">
                    <checkbox v-model="checkboxStatus.checkboxAll" :isPropChecked="checkboxStatus.checkboxAll"></checkbox>
                </span> -->
                <span class="address">地址</span>
                <span class="agent">業務</span>
                <span class="landlord">房東</span>
                <span class="status">房源狀態</span>
                <span class="add-group">加入群組</span>
            </div>
            <div class="table-list-body">
                <div v-show="filterByLandlord.length == 0 && editHouseGroupList.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <!-- <button class="default-button" @click="setFilterDefault">清除篩選</button> -->
                </div>
                <div v-show="editHouseGroupList.length == 0" class="is-empty">無可加入群組房源</div>
                <ul>
                    <li v-for="(list,index) in filterByLandlord" :key="index" :class="{'disabled': list.status === 'INCOMPLETE' || list.status === 'GROUPED'}">
                        <!-- <span class="checkbox" @click="clearSuccessFlag">
                            <checkbox :val="list.houseCid" v-model="housesCid" :isPropDisabled="list.status === 'INCOMPLETE' || list.status === 'GROUPED'" :isPropChecked="checkboxStatus.checkboxAll || checkboxStatus.forceUpdate || list.inGroup"></checkbox>
                        </span> -->
                        <span class="address">{{list.address}}</span>
                        <span class="agent">
                            {{list.agentGroupName+'/'+list.agentName}}
                        </span>
                        <span class="landlord">{{list.landlordName}}</span>
                        <span class="status">
                            <span class="blue" v-if="list.inGroup">已加入</span>
                            <span class="blue" v-else-if="list.status === 'ENABLED'">可選擇</span>
                            <span class="gray" v-else-if="list.status === 'INCOMPLETE'">未完善</span>
                            <span class="gray" v-else-if="list.status === 'GROUPED'">已加入其他群組</span>
                        </span>
                        <span class="add-group">
                            <div class="disabled-mask"></div>
                            <rent-switch v-model="inGroupList[index].inGroup" :dValue="list.inGroup"></rent-switch>
                        </span>
                        <!-- <span v-if="successFlag[index]">
                            <img src="@/assets/img/icon/success_done.svg" alt="">
                        </span> -->
                    </li>
                </ul>
            </div>
        </div>
        <div class="right">
            <edit-house-group-filter></edit-house-group-filter>
        </div>
    </div>
</template>
<script>
import Checkbox from '@/components/bussiness/widges/input/checkbox.vue';
import editHouseGroupFilter from '@/components/bussiness/mgtCategory/houseGroupMgt/editHouseGroup/editHouseGroupFilter.vue';
import RentSwitch from '@/components/widge/RentSwitch.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            checkboxStatus: {
                checkboxAll: false,
                forceUpdate: null
            },
            housesCid: [],
            successFlag: [],
            inGroupList: [],
            totalSelected: 0,
            isFirst: true
        }
    },
    mounted () {
        this.$store.dispatch('getBizEditHouseGroupList')
        .then(()=>{
            setTimeout(()=>{
                this.setEditList(this.filterByLandlord)
            }, 200)
        })
        
    },
    watch: {
        // editHouseGroup: {
        //     handler: function (val) {
        //         console.log(val)
        //         for (let i = 0; i < val.length; i++) {
        //             this.checkboxStatus.checkboxList[i] = false
        //         }
        //     },
        //     immediate: true
        // } ,
        inGroupList: {
            handler: function (val) {
                if(val.length){
                    setTimeout(()=>{
                        let arr = []
                        for (let i = 0; i < val.length; i++) {
                            const element = val[i];
                            if(element.inGroup){
                                arr.push(element.houseCid)
                            }
                        }
                        this.setHouseGroup(arr)
                        this.totalSelected = arr.length
                    }, 100)
                }
            },
            deep: true
        },
        checkboxStatus: {
            handler: function (val) {
                setTimeout(()=>{
                    this.$store.dispatch('setBizEditHouseGroupCheckboxStatus', val)
                },500)
            },
            deep: true
        },
        housesCid: {
            handler: function (newVal, oldVal) {
                this.$store.dispatch('setBizEditHouseGroupSeletedHouse', newVal)
                // this.setHouseGroupName()
                if(newVal.length === 0){
                    this.checkboxStatus.checkboxAll = false
                }else if(this.canSelectCount === newVal.length){
                    this.checkboxStatus.checkboxAll = true
                }
               
            },
            deep: true,
        },
        filterQuery: {
            handler: function (newVal, oldVal) {
                this.setEditList(this.filterByLandlord)
                this.isFirst = true
            },
            deep: true,
        },
        filterQueryUpdate: function () {
            this.clearCheckbox()
        },
        'checkboxStatus.checkboxAll': function (val) {
            this.clearSuccessFlag()
            let list = this.filterByLandlord
            if(val){
                for (let i = 0; i < list.length; i++) {
                    const element = list[i];
                    if(element.status !== 'INCOMPLETE' && element.status !== 'GROUPED' && !this.housesCid.includes(element.houseCid)){
                        this.housesCid.push(element.houseCid)
                    }
                }
            }else{
                this.housesCid = []
            }
        },
        successList: function (val) {     
            this.clearCheckbox()
            for (let i = 0; i < this.filterByLandlord.length; i++) {
                const element = this.filterByLandlord[i];
                if(val.includes(this.filterByLandlord[i].houseId)){
                    this.successFlag[i] = true
                }
            }
        },
        filterByLandlord: function (val){
            this.setInGroupInList()

        }
    },
    methods: {
        setEditList: function (list) {
            this.inGroupList = []
            for (let index = 0; index < list.length; index++) {
                const element = list[index];
                this.inGroupList.push(
                    {
                        "houseCid": element.houseCid,
                        "inGroup" : element.inGroup
                    }
                )
            }
        },
        clearCheckbox: function () {
            this.checkboxStatus.forceUpdate = false
            this.housesCid = []
            setTimeout(()=>{
                this.checkboxStatus.forceUpdate = null
            }, 500)
        },
        clearSuccessFlag: function () {
            this.successFlag = []
        },
        setInGroupInList: function () {
            this.filterByLandlord.forEach((item) => {
                if(!this.housesCid.includes(item.houseCid) && item.inGroup){
                    this.housesCid.push(item.houseCid)
                }
            })
        },
        setHouseGroup: function (arr) {
            let obj = {
                data: {
                    houseGroupId: this.$route.query.cid,
                    editType: 'MULTIPLE',
                    houses: arr
                },
            }
            if(!this.isFirst){
                if(arr.length < this.totalSelected){
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '將房源移除群組，將會影響尚未出帳的屋主對帳單',type: 'error'})
                }else{
                    this.$store.dispatch('setAlarmStatus', {status: true,title: '儲存成功',type: 'success'})
                }
            }
            this.$store.dispatch('editBizHouseGroup', obj )
            .then(()=>{
                this.isFirst = false
            })
        }
    },
    computed: {
        filterByGroup: function () {
            return this.editHouseGroupList.filter((item) => {
                if(this.filterQuery.group){
                    if(item.agentGroupName == this.filterQuery.group ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterBySales: function () {
            return this.filterByGroup.filter((item) => {
                if(this.filterQuery.member){
                    if(item.agentName == this.filterQuery.member ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByCanAddGroup: function () {
            return this.filterBySales.filter((item) => {
                if(this.filterQuery.canAddGroup){
                    if(item.status !== 'INCOMPLETE' && item.status !== 'GROUPED'){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByNoLandlord: function () {
            return this.filterByCanAddGroup.filter((item) => {
                if(this.filterQuery.noLandlord){
                    if(!item.landlordName){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByLandlord: function () {
            return this.filterByNoLandlord.filter((item) => {
                this.filterQueryUpdate
                if(this.filterQuery.landlord){
                    if(item.landlordName == this.filterQuery.landlord){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        canSelectCount: function () {
            let count = 0
            this.filterByLandlord.forEach((item) => {
                if(item.status === 'ENABLED'){
                    count++
                }
            });
            return count
        },
        filterTag: function () {
            let filterTag = []
            let index = 0
            for( var item in this.filterQuery ){
                let filterValue = this.filterQuery[item]
                if(filterValue && item != 'countyId'){
                    filterValue = this.transFilterTagContent(item, filterValue)
                    if( item == 'noSales' || item == 'noLandlord' || item == 'addressCompleted' || item == 'canAddGroup'){
                        filterTag[index] = this.transFilterTagTitle(item)
                    }else{
                        filterTag[index] = this.transFilterTagTitle(item)+'：'+filterValue
                    }
                    index++
                }
            }
            return filterTag
        },
        ...mapGetters({
            editHouseGroupList: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_LIST',
            filterQuery: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_FILTER_QUERY',
            filterQueryUpdate: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_FILTER_QUERY_UPDATE',
            successList: 'GET_BIZ_EDIT_HOUSE_GROUP_MGT_SUCCESS_LIST'
            // housesCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_HOUSE_CID',
            // policyCid: 'GET_BIZ_BATCH_PUBLISH_SELECTED_PUBLISH_CID'
        })
    },
    components: {
        Checkbox,
        editHouseGroupFilter,
        RentSwitch
    }
}
</script>
<style lang="scss">
    .batch-publish-comp{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        .table-list{
            width: 850px;
            .table-list-title{
                padding: 16px;
            }
            .table-list-body ul li{
                padding: 16px;
                &.disabled{
                    color: #a19d9c;
                    background: #fff !important;
                    .add-group{
                        .disabled-mask{
                            position: absolute;
                            width: 100%;
                            height: 100%;
                            z-index: 4;
                        }
                    }
                }
            }
            .checkbox{
                width: 20px;
                margin-right: 16px;
            }
            .address{
                width: 265px;
                margin-right: 30px;
            }
            .agent{
                width: 150px;
                margin-right: 30px;
            }
            .landlord{
                width: 51px;
                margin-right: 55px;
            }
            .status{
                width: 130px;
                margin-right: 55px;
                >span{
                    width: 100%;
                    height: 38px;
                    border-radius: 4px;
                    font-weight: 500;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .gray{
                    background-color: #f3f3f3;
                    color: #676362;
                }
                .blue{
                    background-color: rgba(79, 181, 192, 0.08);
                    color: #71aae5;
                }
            }
            .add-group{
                position: relative;
                width: 85px;
                .disabled-mask{
                    position: absolute;
                }
                .rent-switch{
                    .rent-switch-item{
                        width: 40px;
                        height: 22px;
                        border-radius: 14px;
                        backdrop-filter: blur(6.7px);
                        box-shadow: 0 3px 13px 0 rgba(37, 38, 94, 0.1);
                        &::before{
                            top: 0;
                            left: 0px;
                            width: 40px;
                            height: 23px;
                        }
                        &::after{
                            top: 3px;
                            left: 3px;
                            width: 17px;
                            height: 17px;
                        }
                        &.rent-switch-on{
                            &::after{
                                left: 0px;
                            }
                        }
                    }
                }
            }
            .to-dot{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
        }
    }
    .page-setting.fixed .batch-publish-comp .table-list .table-list-title {
        position: relative;
        top: unset;
        z-index: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseGroupMgt/editHouseGroup/editHouseGroupComp.vue